/**
 * The rail's resting state once a call ends and its note opens. Without it the
 * rail falls back to the pre-join CTA, inviting the doctor back into the call
 * they just finished. Same slot as `<ZoomPanelPreJoin>` / `<ExistingNoteNotice>`.
 */
import { IconCheck } from '@tabler/icons-react'
import { scribeText, SCRIBE_ACCENT } from './scribeText'

export function CallEndedNotice({ onDismiss }: { onDismiss?: () => void }) {
  return (
    <div
      data-testid="zoom-panel-call-ended"
      className="flex flex-1 flex-col items-center justify-center gap-3 px-6 text-center"
    >
      <span
        className="flex h-[34px] w-[34px] items-center justify-center rounded-full bg-[#22c55e]/12 ring-1 ring-[#22c55e]/30"
        aria-hidden
      >
        <IconCheck size={17} stroke={2.5} className="text-[#22c55e]" />
      </span>
      <div className={`${scribeText.title} text-slate-100`}>Call ended</div>
      <p className={`max-w-[210px] ${scribeText.body} leading-relaxed text-slate-400`}>
        The progress note is open for review. Everything from this visit has been saved.
      </p>
      {/* Reclaims the rail's width for the chart — without it the panel has no exit. */}
      <button
        type="button"
        onClick={onDismiss}
        data-testid="zoom-panel-call-ended-dismiss"
        className={`mt-1 rounded-lg px-4 py-2 ${scribeText.label} text-white transition-opacity hover:opacity-90 focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:outline-none`}
        style={{ background: SCRIBE_ACCENT }}
      >
        Close panel
      </button>
    </div>
  )
}
